import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PlanillaEstadisticaService } from '../services/planilla-estadistica.service';
import { PlanillaEstadistica } from '@/app/models/interface/planilla-estadistica.model';

export const planillaEstadisticaResolver: ResolveFn<PlanillaEstadistica> = (
  route,
  state,
) => {
  const service = inject(PlanillaEstadisticaService);

  const id = route.paramMap.get('id');

  return service.findOne(id ? +id : 0);
};
